import { useState, useEffect } from "react";
import { ReactComponent as SubMenuIcon } from "../../assets/icons/sideBarIcon.svg";
import sidemenucss from "../../css/sidemenu.module.css";
import { useHistory } from "react-router-dom";
import { GetPurchase } from "../../../WorkSpace/Components/ApiServices/apiHandler";

const PurchaseSideBar = ({ activeTab, subMenuItem, purchaseID }) => {
  const [regName, setRegName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const redirectTo = (link) => {
    window.location.href = link;
  };

  const routerHistory = useHistory();
  const handleClick = (Link) => {
    routerHistory.push(Link);
  };

  const subMenu = () => {
    if (hideUnHideSubMenu === "A") {
      sethideUnHideSubMenu("I");
    } else {
      sethideUnHideSubMenu("A");
    }
  };

  const [hideUnHideSubMenu, sethideUnHideSubMenu] = useState("A");

  useEffect(() => {
    const fetchPurchaseMeta = async () => {
      try {
        const response = await GetPurchase();
        const purchaseItems = response.data?.purchases || response.data?.Purchase || response.data?.result || [];
        const purchaseArray = Array.isArray(purchaseItems) ? purchaseItems : [purchaseItems];
        const matchedPurchase = purchaseArray.find(
          (item) =>
            item &&
            (item._id === purchaseID || item.id === purchaseID || item.purchaseID === purchaseID)
        );
        const selectedPurchase = matchedPurchase || purchaseArray[0];
        if (selectedPurchase) {
          setRegName(selectedPurchase.regname || selectedPurchase.name || "Purchase Register");
          setCompanyName(
            selectedPurchase.companyData?.company_name ||
            selectedPurchase.companyData?.companyName ||
            selectedPurchase.company_name ||
            ""
          );
        }
      } catch (error) {
        console.error("Failed to load purchase sidebar metadata:", error);
      }
    };

    fetchPurchaseMeta();
  }, [purchaseID]);

  const menuItems = [
    { key: 1, label: "Dashboard", pagelink: `/myfinV2/purchase/dashboard` },
    // {
    //   key: 2,
    //   label: "Lorem Ipsum 1",
    //   pagelink: `/myfinV2/purchase/samplepage1`,
    // },
    // {
    //   key: 3,
    //   label: "Lorem Ipsum 2",
    //   pagelink: `/myfinV2/purchase/samplepage2`,
    // },
    { key: 2, label: "Listing", pagelink: `/myfinV2/purchase/listing` },
  ];

  const activeItem = activeTab;
  const activeItemSubMenu = subMenuItem;

  return (
    <div
      className={`${sidemenucss.sidemenuContainer} ${sidemenucss.sidemenuBackgroundClr}`}
    >
      <div className={sidemenucss.sidemenuHeader}>
        <span className={sidemenucss.sidemenuTitlePS}>{regName || "Purchase Register"}</span>
        <div style={{ textAlign: 'left' }}>
           <p className={sidemenucss.companyText} >
            {companyName || "Company"}
          </p>
        </div>
      </div>
      <div
        className={`${sidemenucss.sidemenuContent} ${sidemenucss.sidemenuLinksFontSize} ${sidemenucss.sidemenuContentTop}`}
      >
        <ul className={sidemenucss.sidemenuList}>
          {menuItems.map((item, index) => (
            <div key={index}>
              <li
                onClick={() => {
                  subMenu();
                  if (item.pagelink) {
                    setTimeout(() => handleClick(item.pagelink), 100);
                  }
                }}
                className={`${sidemenucss.sidemenuItem} ${
                  activeItem === item.label
                    ? sidemenucss.sidemenuItemActive
                    : ""
                }`}
              >
                <span className={sidemenucss.sidemenuItemname}>
                  <div className={sidemenucss.sideMenuItemContainer}>
                    {item.label}
                    <div className={sidemenucss.submenuIcon}>
                      {item.subMenu ? (
                        <SubMenuIcon
                          className={`${sidemenucss.submenuIconSvg} ${
                            hideUnHideSubMenu === "A"
                              ? null
                              : sidemenucss.rotatedIcon
                          }`}
                        />
                      ) : null}
                    </div>
                  </div>
                </span>
              </li>
              {item.subMenu ? (
                <div
                  className={`${sidemenucss.submenuContainer} ${
                    hideUnHideSubMenu === "A"
                      ? sidemenucss.sideMenuShow
                      : sidemenucss.sideMenuHide
                  }`}
                >
                  {item.subMenu.map((sub, idx) => (
                    <div
                      key={idx}
                      className={`${sidemenucss.submenuItem} ${
                        activeItemSubMenu === sub.label
                          ? sidemenucss.activeSubMenu
                          : null
                      }`}
                      onClick={() => handleClick(sub.link)}
                    >
                      {sub.label}
                    </div>
                  ))}
                </div>
              ) : null}
            </div>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PurchaseSideBar;
